import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { AllocationRulesContext } from '../context';
import { SORT_FIELD_TOTAL } from '../rule-helper';
import messages from '../messages';

const SortFieldTotalAscending = ({ allocationRuleId }) => {
  const { allocationRules, setAllocationRules } = useContext(AllocationRulesContext);
  const rule = allocationRules.find((r) => r.allocationRuleId === allocationRuleId);
  const onChange = useCallback(() => {
    rule.sortDesc = false;
    rule.sortField = SORT_FIELD_TOTAL;
    setAllocationRules([...allocationRules.filter((r) => r.allocationRuleId !== rule.allocationRuleId), rule]);
  }, [rule, allocationRules, setAllocationRules]);
  if (rule.sortField === SORT_FIELD_TOTAL && !rule.sortDesc) {
    return null;
  }
  return (
    <DropdownMenuItem onClick={onChange}>
      <FormattedMessage {...messages.allocationStrategiesLowestOrderTotal} />
    </DropdownMenuItem>
  );
};

SortFieldTotalAscending.propTypes = {
  allocationRuleId: PropTypes.string.isRequired,
};

export default SortFieldTotalAscending;
